import { render } from "./SimpleNumber.vue?vue&type=template&id=a09e3808&scoped=true&ts=true"
import script from "./SimpleNumber.vue?vue&type=script&lang=ts"
export * from "./SimpleNumber.vue?vue&type=script&lang=ts"

import "./SimpleNumber.vue?vue&type=style&index=0&id=a09e3808&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a09e3808"]])

export default __exports__